export default __webpack_public_path__ + "static/media/9.f716e32b.png";